import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/agentos.sh/agentos.sh/components/DiagramZoom.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/agentos.sh/agentos.sh/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"optional\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/agentos.sh/agentos.sh/styles/tokens.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/agentos.sh/agentos.sh/app/globals.css");
